var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98053 10.0892C8.90511 9.60752 7.76239 9.36328 6.58408 9.36328H0V11.6875L0.664062 12.6836H11.3457V10.7008L9.98053 10.0892Z",
    fill: "#E0BA7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3457 12.6835V10.7007L9.98053 10.0892C9.49955 9.87371 9.00509 9.70577 8.5 9.58594V12.6835H11.3457Z",
    fill: "#C47E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6511 4.34473V4.68031C10.6511 5.35779 10.0999 5.90896 9.4225 5.90896H8.97724C8.99099 5.79202 8.99806 5.67385 8.99806 5.55495V4.34473H8.00197V5.55495C8.00197 5.93692 7.89472 6.30816 7.70248 6.62884H6.89561C6.21813 6.62884 5.66699 6.07766 5.66699 5.40022V4.34473H4.6709V5.40022C4.6709 6.5353 5.52541 7.47459 6.62494 7.60856C5.93497 8.18938 5.5206 9.06027 5.5206 9.97276V12.0484H6.51669V9.97276C6.51669 9.25298 6.89747 8.57149 7.51033 8.19423L7.53042 8.18185C8.03315 7.87239 8.43009 7.42438 8.68373 6.90509H9.4225C10.6492 6.90509 11.6472 5.90707 11.6472 4.68034V4.34473H10.6511Z",
    fill: "#C47E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1184 0C5.11978 0 4.28051 0.695174 4.05901 1.62695H3.56375C2.67726 1.62695 1.95605 2.34819 1.95605 3.23468C1.95605 4.12114 2.67726 4.84234 3.56375 4.84234H8.50003L8.83206 2.42117L8.50003 0H6.1184Z",
    fill: "#90E36A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4363 1.62695H12.941C12.7195 0.695174 11.8802 0 10.8816 0H8.5V4.84234H13.4363C13.8657 4.84234 14.2694 4.67513 14.5731 4.37146C14.8767 4.06778 15.044 3.66403 15.044 3.23465C15.044 2.34816 14.3228 1.62695 13.4363 1.62695Z",
    fill: "#00CC76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80216 11.6879H0V14.6762H8.5L8.83203 12.8596L8.5 11.043C6.97063 11.471 5.39073 11.6879 3.80216 11.6879Z",
    fill: "#ECD6B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.2998H13.681C11.9635 10.2998 10.2555 10.5397 8.60442 11.0128C8.56966 11.0228 8.53483 11.0326 8.5 11.0424V14.6755H17V10.2998Z",
    fill: "#E0BA7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantou);
export default __webpack_public_path__ + "static/media/plantou.c2c8bc6279f2bebc43f38076f951712f.svg";
export { ForwardRef as ReactComponent };